module.exports = __webpack_public_path__ + "img/aiIcon.370f487a.png";